export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/sl.lyaml"));
at({ "sl": { "public": { "sampleString": "Vzor\u010Dni niz" } } });
};